export const APP_SETTINGS = {
    SETTINGS : {}
};